import icono_localizacion from "./Recursos/Ic_location.svg";
import icono_llamada from "./Recursos/icono_llamada_contacto.svg";
import icono_correo from "./Recursos/icono_correo_contacto.svg";
import icono_nit from "./Recursos/icono_nit_black_contacto.svg";
import icono_localizacion_blanco from "./Recursos/icono_localizacion.svg";
import icono_llamada_blanco from "./Recursos/icono_llamada.svg";
import icono_correo_blanco from "./Recursos/icono_correo.svg";
import icono_nit_blanco from "./Recursos/icono_nit.svg";
import ic_facebook from "./Recursos/icono_facebook.svg";
import ic_instagram from "./Recursos/icono_instagram.svg";
import ic_tiktok from "./Recursos/icono_tiktok.svg";


export const SECCIONES = [
    'Home', 'Documentacion', 'Contactos'
]

export const LINKWHATSAPP = 'https://api.whatsapp.com/send?phone=573183650310'

export const CONTACTOS = [
    {
        nombre: 'Direccion',
        descripcion: 'Cll 18a 41-66 Valle de Atriz - Pasto - Nariño',
        img: icono_localizacion,
        imgBlanco: icono_localizacion_blanco
    },
    {
        nombre: 'Celular',
        descripcion: '+57 318 365 0310',
        img: icono_llamada,
        imgBlanco: icono_llamada_blanco
    },
    {
        nombre: 'Email',
        descripcion: 'fundhap2@gmail.com',
        img: icono_correo,
        imgBlanco: icono_correo_blanco
    },
    {
        nombre: 'Nit',
        descripcion: '900166064-9',
        img: icono_nit,
        imgBlanco: icono_nit_blanco
    },
]


export const REDES = [
    {
        nombre: 'facebook',
        link:'https://www.facebook.com/fundhapasto/?locale=es_LA',
        img: ic_facebook
    },
    {
        nombre: 'instagram',
        link:'https://www.instagram.com/fundhappasto/' +
            '',
        img: ic_instagram
    },
    {
        nombre: 'tiktok',
        link:'https://www.tiktok.com/@fundhap',
        img: ic_tiktok
    },
]
